import { useQuery } from "@tanstack/react-query";
import { applicationsApi } from "api/applications";
import { Applicant } from "types/application";

export const useApplicantDetail = (
  applicationId: string | number | undefined,
  applicantId: string | number | undefined
) =>
  useQuery<Applicant>({
    queryKey: [
      "APPLICATION",
      String(applicationId),
      "applicant",
      String(applicantId)
    ],
    queryFn: () =>
      applicationsApi.getApplicantDetail(
        String(applicationId),
        String(applicantId)
      ),
    enabled: !!applicationId && !!applicantId
  });
